// Payment Setup (Broker) — the guided payout-account onboarding for a broker.
// Identical to the seller flow; the shared PayeePaymentSetupPanel holds the UI
// and this tab wires in the broker's api module.

import { PayeePaymentSetupPanel } from "../components/PayeePaymentSetupPanel";
import { brokerPaymentSetupApi } from "../api/paymentSetup";

export function BrokerPaymentSetupTab() {
  return <PayeePaymentSetupPanel api={brokerPaymentSetupApi} />;
}
